import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { OneSignal } from 'onesignal-ngx';
import { LoginService } from 'src/app/shared/services/authservices/login.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { DeviceUuidService } from 'src/app/shared/services/deviceuuidservices/device-uuid.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule,]
})
export class UpdatePasswordComponent implements OnInit {
  public showSpinner = false;
  public user: any = [];
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  deviceUuid: any;
  constructor(
    private loginService: LoginService,
    private router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private deviceUuidService: DeviceUuidService,
    private oneSignal: OneSignal

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
  }
  ngOnInit(): void {
    this.deviceUuid = localStorage.getItem("userDeviceID_OneSignal_subcripptio")
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

    if (localStorage.getItem('userDeviceID_OneSignal_subcripptio') == "" || localStorage.getItem('userDeviceID_OneSignal_subcripptio') == null) {
      this.getDeviceID()
    }
  }
  getDeviceID() {
    //Get ID for Onesignla External ID
    const userID = this.user?.id ?? "15500"
    this.oneSignal.login(String(userID)).then(value => {
      const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
      if (userDeviceID_OneSignal_subcripptio.length > 5) {
        this.deviceUuid = userDeviceID_OneSignal_subcripptio
        localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
      }
    })
    const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
    if (userDeviceID_OneSignal_subcripptio.length > 5) {
      this.deviceUuid = userDeviceID_OneSignal_subcripptio
      localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
    }
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  copyToDeviceUuid(): void {
    if (this.deviceUuid == null || this.deviceUuid == undefined || this.deviceUuid == "") {
      this.getDeviceID()
    } else {
      const el = document.createElement('textarea');
      el.value = this.deviceUuid;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      alert('Device UUID copied!');
    }

  }
  onSubmit(f: NgForm) {
    this.showSpinner = true;
    const OldPassword = f.value.OldPassword;
    const newPassword = f.value.newPassword;
    const confirm_newPassword = f.value.confirmnewPassword;
    if (OldPassword.length == 0) {
      this.showError("Old Password Missing!")
      return;
    }
    if (newPassword.length == 0) {
      this.showError("New Password Missing!")
      return;
    }

    if (confirm_newPassword.length == 0) {
      this.showError("Confirm Password Missing!")
      return;
    }

    if (confirm_newPassword != newPassword) {
      this.showError("Password Not Matched!")
      return;
    }

    this.loginService.updatePassword(this.user.email, newPassword, OldPassword).then((value) => {
      this.showSpinner = false;
      if (value.success == true && value.message != "your old password is incorrect") {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.router.navigate(['user-dashboard']);
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }




  updatePin(p: NgForm) {
    this.showSpinner = true;
    const OldPin = p.value.oldPin;
    const newPin = p.value.newPin;
    const confirm_newPin = p.value.confirmNewPin;
    if (OldPin.length == 0) {
      this.showError("Old Pin Missing!")
      return;
    }
    if (newPin.length == 0) {
      this.showError("New Pin Missing!")
      return;
    }

    if (confirm_newPin.length == 0) {
      this.showError("Confirm Pin Missing!")
      return;
    }

    if (confirm_newPin != newPin) {
      this.showError("Pin Not Matched!")
      return;
    }
    this.loginService
      .updatePinCode(this.user.email,
        newPin,
        OldPin)
      .then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Pin Updated Successffully!',
            showConfirmButton: false,
            timer: 1500,
          });
          this.router.navigate(['user-dashboard']);
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
  }

  showError(message: string) {
    Swal.fire({
      iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
      title: message,
      showConfirmButton: false,
      timer: 3000,
    });
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  resetPassword() {
    this.showSpinner = true;
    this.dashboardService.passwordReset().then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.showSpinner = false;

    })
  }
  resetPin() {
    this.showSpinner = true;
    this.dashboardService.pinReset().then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.showSpinner = false;

    })
  }


}
